import { downloadApiExport, translationsWithFallback } from "helpers/utils";
import { t } from "i18next";
import { toast } from "react-toastify";

import { createAppAsyncThunk } from "../appAsyncThunk";
import type {
    AdvanceProvisionList,
    AdvanceProvisionListParams,
    AdvanceProvisionRule,
    AdvanceProvisionRulesResponse,
    AdvanceProvisionRuleType,
} from ".";

const errorMessage = (error: any) => translationsWithFallback(error?.response?.data?.message);

export const fetchAdvanceProvisionRules = createAppAsyncThunk<AdvanceProvisionRulesResponse, void>(
    "advanceProvision/fetchRules",
    async (_, { extra, rejectWithValue }) => {
        try {
            return await extra.advanceProvisionRepository.fetchRules();
        } catch (error: any) {
            toast.error(errorMessage(error));
            return rejectWithValue(errorMessage(error));
        }
    },
);

export const saveAdvanceProvisionRules = createAppAsyncThunk<
    AdvanceProvisionRule[],
    { ruleType: AdvanceProvisionRuleType; rules: AdvanceProvisionRule[] }
>("advanceProvision/saveRules", async ({ ruleType, rules }, { extra, rejectWithValue }) => {
    try {
        const saved = await extra.advanceProvisionRepository.saveRules(ruleType, rules);
        toast.success(`${t("AdvanceProvision.Settings.Saved")}`);
        return saved;
    } catch (error: any) {
        toast.error(errorMessage(error));
        return rejectWithValue(errorMessage(error));
    }
});

export const fetchAdvanceProvisionList = createAppAsyncThunk<AdvanceProvisionList, AdvanceProvisionListParams>(
    "advanceProvision/fetchList",
    async (params, { extra, rejectWithValue }) => {
        try {
            return await extra.advanceProvisionRepository.fetchList(params);
        } catch (error: any) {
            toast.error(errorMessage(error));
            return rejectWithValue(errorMessage(error));
        }
    },
);

export const exportAdvanceProvision = createAppAsyncThunk<void, string>(
    "advanceProvision/export",
    async (closingDate, { extra, rejectWithValue }) => {
        const toastId = toast.loading(`${t("Export.Pending")}`);
        try {
            const file = await extra.advanceProvisionRepository.exportList(closingDate);
            downloadApiExport(file, `provision_a-valoir_${closingDate}.xlsx`);
            toast.update(toastId, {
                render: `${t("Export.Successful")}`,
                type: "success",
                isLoading: false,
                autoClose: 5000,
            });
        } catch (error: any) {
            toast.update(toastId, { render: `${t("Export.Error")}`, type: "error", isLoading: false, autoClose: 5000 });
            return rejectWithValue(errorMessage(error));
        }
    },
);
